export default __webpack_public_path__ + "static/media/android.59857543.svg";